"use strict";

;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  // (optional) to prevent double loading/execution in SPA mode
  var loaded = false;

  /**
   * Do stuff on the page load
   */
  function onPageLoad() {
    if (loaded) {
      // (optional) to prevent double loading/execution in SPA mode
      return;
    }
    loaded = true;

    // if (!FlixUtils.isMobile()) {
    //     document.querySelectorAll('img[data-src-desktop]').forEach(function (img) {
    //         var src = img.getAttribute('data-src-desktop');
    //         if (src) {
    //             img.setAttribute('src', src);
    //             img.removeAttribute('data-src-desktop');
    //         }
    //     });
    // }
  }
})();